export default __webpack_public_path__ + "static/media/JackboxGames.c24a22a3.yaml";